import React, { useState, useEffect } from 'react';
import styles from './CollectionSelector.module.css';

function CollectionSelector({ onSelectCollection }) {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const response = await fetch('/collections.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setCollections(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

  // Modal overlay wrapper
  return (
    <div className={styles.collection_selector_modal_overlay}>
      <div className={styles.collection_selector_modal}>
        {loading ? (
          <div className="collection-selector">Loading collections...</div>
        ) : error ? (
          <div className="collection-selector error">Error loading collections: {error.message}</div>
        ) : (
          <>
            <h2>Select a Song Collection</h2>
            <div className={styles.collection_list}>
              {collections.map((collection) => (
                <div key={collection.file} className={styles.collection_item}>
                  <h3>{collection.name}</h3>
                  <p>{collection.description}</p>
                  <p>Songs: {collection.song_count}</p>
                  <button onClick={() => onSelectCollection(collection.file)}>Select</button>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CollectionSelector;